var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnosInstitucije(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "30px",
    height: "30px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.16 788.48H419.84V947.2c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6V762.88c0-14.138 11.462-25.6 25.6-25.6h235.52c14.138 0 25.6 11.462 25.6 25.6V947.2c0 14.138-11.462 25.6-25.6 25.6s-25.6-11.462-25.6-25.6V788.48zm385.033 130.041c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-80.475c-14.138 0-25.6-11.462-25.6-25.6V347.279a5.12 5.12 0 00-5.12-5.12H530.98c-25.449 0-46.08-20.631-46.08-46.08V123.205a5.12 5.12 0 00-5.12-5.12H141.694a5.12 5.12 0 00-5.12 5.12V946.48c0 14.138-11.462 25.6-25.6 25.6H27.521c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6h57.853V123.205c0-31.105 25.215-56.32 56.32-56.32H479.78c31.105 0 56.32 25.215 56.32 56.32v167.754h341.898c31.105 0 56.32 25.215 56.32 56.32v571.242h54.875zM220.16 174.08h184.32c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6H220.16c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm0 112.64h184.32c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6H220.16c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm0 112.64h583.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6H220.16c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm0 112.64h583.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6H220.16c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm0 112.64h583.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6H220.16c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm0 112.64h71.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-71.68c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm512 0h71.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-71.68c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm-512 122.88h71.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-71.68c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6zm512 0h71.68c14.138 0 25.6 11.462 25.6 25.6s-11.462 25.6-25.6 25.6h-71.68c-14.138 0-25.6-11.462-25.6-25.6s11.462-25.6 25.6-25.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 300)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 280,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140 0h280M0 -140v280",
    stroke: "#fff",
    strokeWidth: 55,
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnosInstitucije);
export default __webpack_public_path__ + "static/media/UnosInstitucije.f38b5e78388ec1048ae8b25bf015676b.svg";
export { ForwardRef as ReactComponent };